import axios, { AxiosInstance } from 'axios';
import { loadRuntimeConfig } from '../config/config.js';
import { sessionStorage } from '../services/sessionStorage';

let apiProxy: Promise<AxiosInstance> | undefined;
export default function getApiProxy(): Promise<AxiosInstance> {
    apiProxy ??= (async () => {
        const { baseApiUrl } = await loadRuntimeConfig();
        const api = axios.create({ baseURL: baseApiUrl, withCredentials: true, headers: { 'X-CSRF-Protection': '1' } });
        api.interceptors.request.use(async (config) => {
            const token = await sessionStorage.getToken();
            if (token && !config.headers['Authorization']) config.headers['Authorization'] = `Bearer ${token}`;
            return config;
        });
        api.interceptors.response.use((response) => response, async (error) => {
            if (error.response?.status === 401) {
                await sessionStorage.clear();
                window.dispatchEvent(new Event('session-ended'));
            }
            return Promise.reject(error);
        });
        return api;
    })().catch((error) => { apiProxy = undefined; throw error; });
    return apiProxy;
}
